/**
 * Industry Metrics view configuration constants.
 * Centralizes view types, storage keys, and event names.
 */

// View types for Industry Metrics
export const INDUSTRY_METRICS_VIEWS = {
  TABLE: 'table',
  CHART: 'chart',
  SCATTER: 'scatter',
  TRENDED: 'trended',
  QUADRANT: 'quadrant',
  ACCELERATION: 'acceleration',
};

// Storage key for view preference persistence
export const INDUSTRY_METRICS_VIEW_STORAGE_KEY = 'industryMetricsView';

// Event name for cross-component view change communication
export const INDUSTRY_METRICS_VIEW_EVENT_NAME = 'metricsViewChange';

// Tickers to exclude from all views
export const EXCLUDED_TICKERS = [];
